import React from 'react'
import Geosuggest from 'react-geosuggest'
import Field from '../../common/FormField'
import { errorClassName, withGeoSuggestInput } from '../../../utils/form'
import { statusCodes } from '../../../utils/retailer'

import 'react-geosuggest/module/geosuggest.css'
import styles from '../Form.module.css'

const StoreInfo = ({
  data,
  isBasicRetailer,
  isAdminUser,
  error = {},
  onChangeFactory,
  onGeoInputChange,
  onGeoSuggestSelect,
  disabled
}) => {
  const isPrivateSeller = data.statusCode === statusCodes.PRIVATE.value
  return (
    <fieldset>
      <Field type="input" name="Seller Name / Store Name *" error={error.name}>
        <input
          type="text"
          placeholder="Enter a name visible to the public"
          value={data.name}
          onChange={onChangeFactory('name')}
          disabled={disabled}
        />
      </Field>
      {!isBasicRetailer &&
        <Field type="textarea" name="Seller Description">
          <textarea
            rows="5"
            className="custom-scroll"
            placeholder="Enter a description that describes you or your services (i.e. a bit about you, your mission statement, the experience in your store, if relevant, a key differentiating factor, etc.) "
            value={data.description}
            onChange={onChangeFactory('description')}
            disabled={disabled}
          />
        </Field>}
      <section>
        <div className="row">
          <div className="col col-8">
            <label className="label">
              Location (City, State, Country), or Store Address (if relevant) *
            </label>
            <label className={`input ${errorClassName(error.storeAddress)}`}>
              <Geosuggest
                placeholder="i.e. NYC, New York, United States"
                initialValue={data.gmapStreetAddr}
                location={
                  window.google
                    ? new window.google.maps.LatLng(43.653226, -79.38318429999998)
                    : undefined
                }
                radius={20}
                className={styles.addressInput}
                onChange={onGeoInputChange}
                onSuggestSelect={onGeoSuggestSelect}
              />
            </label>
            {error.storeAddress
              ? <label className="note-error">
                  <em className="invalid">
                    {error.storeAddress}
                  </em>
                </label>
              : null}
          </div>
          <div className="col col-4">
            <label className="label">Unit # (Optional)</label>
            <label className="input">
              <input
                type="text"
                placeholder="Enter the unit # if it applies"
                value={data.storeUnit}
                onChange={onChangeFactory('storeUnit')}
                disabled={disabled}
              />
            </label>
          </div>
        </div>
      </section>
      <Field
        type="toggle"
        note="Turn this option on to protect your listing with an access code. (Warning: you CANNOT turn it off once it is on, please contact us support@mydiamondrevolution.com if you need to make a change."
      >
        <input
          type="checkbox"
          checked={data.isPrivate}
          onChange={onChangeFactory('isPrivate')}
          disabled={(isPrivateSeller && !isAdminUser) || disabled}
        />
        <i data-swchon-text="ON" data-swchoff-text="OFF" />
        Private Listing
      </Field>
      {(isPrivateSeller || data.isPrivate) &&
        <Field type="input" name="Access Code" error={error.privatePassword}>
          <input
            type="text"
            placeholder="Enter an access code to view your private listing"
            value={data.privatePassword}
            onChange={onChangeFactory('privatePassword')}
            disabled={(isPrivateSeller && !isAdminUser) || disabled}
          />
        </Field>}
    </fieldset>
  )
}

export default withGeoSuggestInput(StoreInfo)
